import { useCallback } from 'react';
import { useQuery } from 'react-query';

import PostSaleService from '../../services/PostSaleService';
import { SHIPPING, SHIPPING_OMP } from '../constants/queryDefinition';
import Shipping from '../models/Shipping';
import ErrorService from '../../services/ErrorService';
import { COUNTRY_CODE } from '../constants/country';

const useShipping = (
  isMultiOrgAndEnabled,
  tradeId: number,
  dealerId?: number
) => {
  const getShippingEstimate = useCallback(async () => {
    const response = await PostSaleService[
      isMultiOrgAndEnabled ? 'getShippingEstimateV2' : 'getShippingEstimate'
    ](tradeId, dealerId!);

    return response;
  }, [dealerId, isMultiOrgAndEnabled, tradeId]);

  const getShipping = useCallback(async () => {
    try {
      const shippingEstimateResponse = await getShippingEstimate();

      return new Shipping(shippingEstimateResponse, COUNTRY_CODE.CA);
    } catch (e) {
      ErrorService.trackError(e);
      return new Shipping(null, COUNTRY_CODE.CA);
    }
  }, [getShippingEstimate]);

  // TODO change name
  return useQuery([SHIPPING.KEY, tradeId, dealerId], getShipping, {
    enabled: !!(tradeId && dealerId),
    refetchOnMount: true,
    refetchOnWindowFocus: !isMultiOrgAndEnabled,
    refetchOnReconnect: true,
    refetchInterval: SHIPPING.REFETCH_INTERVAL,
    staleTime: isMultiOrgAndEnabled
      ? SHIPPING_OMP.STALE_TIME
      : SHIPPING.REFETCH_INTERVAL,
    retry: false
  });
};

export default useShipping;
